module.exports = __webpack_public_path__ + "18a6e21cbb053355af08c692f387b070.MP3";